module.exports = __webpack_public_path__ + "static/village_card_img5@2x-b59cf71d70bb3978c49fa850bdf50c6f.png";